import { css } from '@emotion/react';
import { useCallIntelDefaultsShallowStore } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';
import { useActiveFilters } from './hooks/use-active-filters';
import { useCallIntelLocations } from './hooks/use-call-intel-locations';
import { useCallIntelShallowStore } from './hooks/use-call-intel-store';

type Props = {
  label?: string;
  addPrefix?: boolean;
};

export const CustomTooltipTitle = ({ addPrefix, label }: Props) => {
  const { t } = useTranslation('analytics');
  const { dataLabels } = useCallIntelDefaultsShallowStore('dataLabels');
  const { subView } = useCallIntelShallowStore('subView');
  const { filters } = useActiveFilters();
  const { isMultiLocation } = useCallIntelLocations();

  const locationCount = filters.locations?.length ?? 0;
  const prefix = addPrefix
    ? `${
        {
          ...dataLabels.appointmentTypes,
          ...dataLabels.categories,
          ...dataLabels.sentimentsWithEmoji,
        }[subView?.id || '']
      }: `
    : '';
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing(1)};
      `}
    >
      <Text color='subdued' size='small'>
        {prefix + label}
      </Text>
      {isMultiLocation && (
        <Chip.Location>
          {t('{{count}} {{label}}', { count: locationCount, label: locationCount > 1 ? 'Locations' : 'Location' })}
        </Chip.Location>
      )}
    </div>
  );
};
